import React from 'react';
import PageTemplate from '../components/PageTemplate';

/**
 * Page Mentions légales
 */
const Legal = () => {
  return <PageTemplate slug="legal" />;
};

export default Legal;
